import { getBranchesLocations } from '../../services/api/branch.api';
import { GET_LOCATION_LIST_REQUEST, GET_LOCATION_LIST_SUCCESS, GET_LOCATION_LIST_FAILURE } from '../types';
import { transformLocations } from '../../transforms/location';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformLocations([]),
	},

	getters: {
		locationOptions: (state) => {
			const location = {
				name: 'All locations',
				value: null,
			};

			const locations = state.data.map((item) => {
				return {
					name: item.name,
					value: item.id,
				};
			});

			return [location, ...locations];
		},
	},

	mutations: {
		[GET_LOCATION_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_LOCATION_LIST_SUCCESS](state, { data }) {
			state.isLoading = false;
			state.data = transformLocations(data);
		},
		[GET_LOCATION_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getLocations({ commit }) {
			try {
				commit(GET_LOCATION_LIST_REQUEST);
				const { data } = await getBranchesLocations();
				commit(GET_LOCATION_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_LOCATION_LIST_FAILURE, error);
			}
		},
	},
};